import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { SiteLayout } from "@/components/SiteLayout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import BrandStory from "@/pages/BrandStory";
import Products from "@/pages/Products";
import Franchise from "@/pages/Franchise";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import MemberDashboard from "@/pages/MemberDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import VoucherVerify from "@/pages/VoucherVerify";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <LanguageProvider>
          <SettingsProvider>
            <BrowserRouter>
              <Toaster position="top-center" richColors />
              <Routes>
                <Route element={<SiteLayout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/story" element={<BrandStory />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/franchise" element={<Franchise />} />
                  <Route path="/news" element={<News />} />
                  <Route path="/news/:id" element={<NewsDetail />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/member" element={<ProtectedRoute><MemberDashboard /></ProtectedRoute>} />
                </Route>
                <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
                <Route path="/verify/:code" element={<VoucherVerify />} />
              </Routes>
            </BrowserRouter>
          </SettingsProvider>
        </LanguageProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
